import { extractStoreNameFromUrl } from './extractStoreNameFromUrl';

/**
 * Replaces all occurrences of <shopify_store_name> in the input string with the provided storeUrl.
 * @param {string} str - The string containing the <shopify_store_name> placeholder.
 * @param {string} storeUrl - The Shopify store URL to insert.
 * @returns {string} - The string with the placeholder replaced.
 */
export function replaceShopifyDomain(str: string, storeUrl: string): string {
    const storeName = extractStoreNameFromUrl(storeUrl) ?? '';

    return str.replace(/<shopify_store_name>/g, storeName);
}
